export default "__VITE_ASSET__DMZQXLjR__"